module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Black.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Black.eot
// module id = 13
// module chunks = 8